import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const permissions = createQueryKeys('permissions', {
  all: null,
})

export type CountryKeys = inferQueryKeys<typeof permissions>
